export default {
  IS_CONTAINER_PICK: "isContainerPick",
  START_ORDER: "startOrder",
  SET_CONTAINER_SCAN_VALIDATION: "setContainerScanValidation",
  PICK_CONTAINER_STOCK: "pickContainerStock",
} as const;
